var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "scratchWorksPlay" }, [
    _c("div", { staticClass: "works-ralative" }, [
      _vm.scratchLoading
        ? _c("div", { staticClass: "worksLoading" }, [
            _c("img", { attrs: { src: _vm.themeData.logo, alt: "" } }),
            _vm._v(" "),
            _c("div", { staticClass: "scratch-loading" }, [
              _c("div", {
                staticClass: "filled",
                style: `width: ${_vm.width}%`,
              }),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { attrs: { id: "scratch-player" } }),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.keyboard != 1,
            expression: "keyboard != 1",
          },
        ],
        staticClass: "panel-container f-cb",
      },
      [
        _vm.keyboard == 2
          ? _c("div", { staticClass: "keyboardBox" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", {
                staticClass: "space f-fr",
                attrs: { id: "mspaceBtn" },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "q", attrs: { id: "mqBtn" } }, [
                _vm._v("Q"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "w", attrs: { id: "mwBtn" } }, [
                _vm._v("W"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "e", attrs: { id: "meBtn" } }, [
                _vm._v("E"),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.keyboard == 3
          ? _c("div", { staticClass: "keyboardBox" }, [
              _vm._m(1),
              _vm._v(" "),
              _vm._m(2),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.keyboard == 4
          ? _c("div", { staticClass: "keyboardBox" }, [_vm._m(3)])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "playGame", attrs: { id: "playGame" } }, [
          _vm._v("开始"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "stopGame", attrs: { id: "stopGame" } }, [
          _vm._v("结束"),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "sxzu-bar-one" }, [
      _c("div", {
        staticClass: "key left arrow-left",
        attrs: { id: "mleftBtn" },
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "key down arrow-down",
        attrs: { id: "mdownBtn" },
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "key right arrow-right",
        attrs: { id: "mrightBtn" },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "key up arrow-up", attrs: { id: "mupBtn" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "sxzu-bar" }, [
      _c("div", {
        staticClass: "key left arrow-left",
        attrs: { id: "mleftBtn" },
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "key down arrow-down",
        attrs: { id: "mdownBtn" },
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "key right arrow-right",
        attrs: { id: "mrightBtn" },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "key up arrow-up", attrs: { id: "mupBtn" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "sxzu-bar-wasd" }, [
      _c("div", { staticClass: "key keyW arrow-w", attrs: { id: "mwBtn" } }, [
        _vm._v("W"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "key keyA arrow-a", attrs: { id: "maBtn" } }, [
        _vm._v("A"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "key keyS arrow-s", attrs: { id: "msBtn" } }, [
        _vm._v("S"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "key keyD arrow-d", attrs: { id: "mdBtn" } }, [
        _vm._v("D"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "num-keypad" }, [
      _c("div", { staticClass: "key number", attrs: { id: "m7Btn" } }, [
        _vm._v("7"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "key number", attrs: { id: "m8Btn" } }, [
        _vm._v("8"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "key number", attrs: { id: "m9Btn" } }, [
        _vm._v("9"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "key number", attrs: { id: "m4Btn" } }, [
        _vm._v("4"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "key number", attrs: { id: "m5Btn" } }, [
        _vm._v("5"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "key number", attrs: { id: "m6Btn" } }, [
        _vm._v("6"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "key number", attrs: { id: "m1Btn" } }, [
        _vm._v("1"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "key number", attrs: { id: "m2Btn" } }, [
        _vm._v("2"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "key number", attrs: { id: "m3Btn" } }, [
        _vm._v("3"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/scratchWorksPlay/scratchWorksPlay.vue?vue&type=template&id=32f88785&scoped=true&
// module id = null
// module chunks = 